import React from 'react';
import ProductItemView from '../ProductItemView';
import interoperability from '../../resource/middleware/interoperability.svg';

const Interoperability = () => {
    return (
        <ProductItemView
            title="Interoperabilidad"
            items={["Middleware funciona con un patrón de adapatadores, lo que nos permite conectarlo a cualquier sistema informático", "Podemos conectar los servicios/sistemas periféricos al LIS"]}
            image={interoperability}
            centered />
    );
};

export default Interoperability;